<script setup>
import { defineProps, ref } from 'vue';
import { useForm, useField, useIsFormValid } from 'vee-validate';
import * as yup from 'yup';

const props = defineProps(
    ['request']
)
const requestData = JSON.parse(props.request);

const phoneCheckJpRegExp = /^0\d{9,10}$|^0\d{1,4}-\d{1,4}-\d{3,4}$/;
const fullWidthHiraganaCharRegExp = /^[\u3040-\u309F　]+$/;

const { errors } = useForm();
const isValid = useIsFormValid();
const { value: name } = useField('name', yup.string().required('お名前(漢字)は入力必須です'));
const { value: nameKana } = useField('name_kana', yup.string().required('お名前(ふりがな)は入力必須です').matches(fullWidthHiraganaCharRegExp, 'お名前(ふりがな)は全角ひらがなでご入力してください'));
const { value: age } = useField( 'age', yup.string().required('年齢は選択必須です'));
const { value: email } = useField('email', yup.string().required('メールアドレスは入力必須です').email('メールアドレスを正しくご入力してください'));
const { value: tel } = useField('tel', yup.string().required('電話番号は入力必須です').matches(phoneCheckJpRegExp, '電話番号を正しく入力してください'));
const { value: reserve01 } = useField('reserve01', yup.string().required('予約希望日(第一希望)は入力必須です'));
let reserve02 = ref('');
let reserve03 = ref('');
let request = ref('');
const { value: privacy } = useField('privacy', yup.string().required('個人情報の取り扱いについては必ずご確認と同意頂く必要があります'));

if(requestData){
    name.value = requestData.name;
    nameKana.value = requestData.name_kana;
    age.value = requestData.age;
    email.value = requestData.email;
    tel.value = requestData.tel;
    reserve01.value = requestData.reserve01;
    reserve02 = requestData.reserve02;
    reserve03 = requestData.reserve03;
    request = requestData.request;
}
</script>

<template>
    <table class="p-reserve-content__form__input">
        <tr>
            <th class="is-required">お名前(漢字)</th>
            <td>
                <input type="text" name="name" v-model="name">
                <p class="error">
                    {{errors.name}}
                </p>
            </td>
        </tr>
        <tr>
            <th class="is-required">お名前(ふりがな)</th>
            <td>
                <input type="text" name="name_kana" v-model="nameKana">
                <p class="error">
                    {{errors.name_kana}}
                </p>
            </td>
        </tr>
        <tr>
            <th class="is-required">メールアドレス</th>
            <td>
                <input type="email" name="email" v-model="email">
                <p class="error">
                    {{errors.email}}
                </p>
            </td>
        </tr>
        <tr>
            <th class="is-required">電話番号</th>
            <td>
                <input type="text" name="tel" v-model="tel">
                <p class="error">
                    {{errors.tel}}
                </p>
            </td>
        </tr>
        <tr>
            <th class="is-required">年齢</th>
            <td>
                <div class="p-reserve-content__form__age">
                <select name="age" v-model="age">
                    <option value="">選択してください</option>
                    <option v-for="i in 99" :key="i" :value="i">{{i}}歳</option>
                </select>
                </div>
                <p class="error">
                    {{errors.age}}
                </p>
            </td>
        </tr>
        <tr>
            <th class="is-required">予約希望日(第一希望)</th>
            <td>
                <div class="p-reserve-content__form__date">
                    <input type="datetime-local" name="reserve01" v-model="reserve01">
                </div>
                <p class="error">
                    {{errors.reserve01}}
                </p>
            </td>
        </tr>
        <tr>
            <th>予約希望日(第二希望)</th>
            <td>
                <div class="p-reserve-content__form__date">
                    <input type="datetime-local" name="reserve02" v-model="reserve02">
                </div>
            </td>
        </tr>
        <tr>
            <th>予約希望日(第三希望)</th>
            <td>
                <div class="p-reserve-content__form__date">
                    <input type="datetime-local" name="reserve03" v-model="reserve03">
                </div>
            </td>
        </tr>
        <tr>
            <th>ご要望・ご質問</th>
            <td><textarea name="request" v-model="request"></textarea></td>
        </tr>
    </table>
    <div class="p-reserve-content__form__privacy">
        <p class="p-reserve-content__form__privacy__check">
            <label>
                <input type="checkbox" name="privacy" v-model="privacy">
                <span>個人情報の取扱いについて同意する</span>
            </label>
        </p>
        <p class="p-reserve-content__form__privacy__link">
            <a href="/privacy" target="_blank">個人情報の取り扱いについて</a>
        </p>
        <p class="error">
            {{errors.privacy}}
        </p>
    </div>
    <div v-if="!errors || !isValid" class="p-reserve-content__form__submit c-btn is-disabled">
        <span>確認画面へ進む</span>
    </div>
    <div v-else class="p-reserve-content__form__submit c-btn">
        <input type="submit" value="確認画面へ進む">
    </div>
</template>
